"use strict";

exports.__esModule = true;
exports.Earns = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _graphqlRequest = require("graphql-request");
var _baseHistoryFetcher = require("../base-history-fetcher");
var _resolveLinks = require("../utils/resolve-links");
var _getChainType = require("../../utils/get-chain-type");
class Earns extends _baseHistoryFetcher.BaseHistoryFetcher {
  constructor(configs) {
    super(configs);
    this.getPoolId = pool => {
      var _this$configs$wallet$;
      return pool !== null && pool !== void 0 && pool.includes('-') ? (_this$configs$wallet$ = this.configs.wallet.getToken(pool.split('-')[1])) === null || _this$configs$wallet$ === void 0 ? void 0 : _this$configs$wallet$.display : pool;
    };
  }
  async fetch(params) {
    const variables = {
      account: params.address
    };
    const paramsSchema = `$account: String`;
    const filterSchema = `filter: { addressId: { equalTo: $account } }`;
    const claimRewardsResultShema = `
      nodes {
        id
        addressId
        tokenId
        pool
        actualAmount
        deductionAmount
        blockNumber
        extrinsic
        timestamp
      }
    `;
    const payoutRewardsResultShema = `
      nodes {
        id
        addressId
        tokenId
        pool
        actualPayout
        deductionAmount
        blockNumber
        extrinsic
        timestamp
      }
    `;
    const depositAndwithdrawResultShema = `
      nodes {
        id
        addressId
        tokenId
        amount
        blockNumber
        extrinsic
        timestamp
      }
    `;
    const result = await (0, _graphqlRequest.request)(this.configs.endpoint, (0, _graphqlRequest.gql)`
        query(${paramsSchema}){
          claimRewards(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${claimRewardsResultShema}
          }
          payoutRewards(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${payoutRewardsResultShema}
          }
          depositDexShares(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${depositAndwithdrawResultShema}
          }
          withdrawDexShares(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${depositAndwithdrawResultShema}
          }
        }
      `, variables);
    return this.transform(result);
  }
  transform(data) {
    const claimRewards = data.claimRewards.nodes.map(item => {
      return {
        data: item,
        message: this.createMessage('claimRewards', item),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'incentives.ClaimRewards',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const payoutRewards = data.payoutRewards.nodes.map(item => {
      return {
        data: item,
        message: this.createMessage('payoutRewards', item),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'incentives.PayoutRewards',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const depositDexShares = data.depositDexShares.nodes.map(item => {
      return {
        data: item,
        message: this.createMessage('depositDexShares', item),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'incentives.DepositDexShare',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    const withdrawDexShares = data.withdrawDexShares.nodes.map(item => {
      return {
        data: item,
        message: this.createMessage('withdrawDexShares', item),
        resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
        method: 'incentives.WithdrawDexShare',
        extrinsicHash: item.extrinsic,
        blockNumber: item.blockNumber
      };
    });
    return claimRewards.concat(payoutRewards).concat(withdrawDexShares).concat(depositDexShares).sort((a, b) => new Date(b.data.timestamp) < new Date(a.data.timestamp) ? -1 : 1).slice(0, 20);
  }
  createMessage(type, data) {
    const token = this.configs.wallet.getToken((0, _sdkCore.forceToCurrencyName)(data.tokenId));
    if (type === 'claimRewards') {
      const amount = _sdkCore.FixedPointNumber.fromInner(data.actualAmount || '0', (token === null || token === void 0 ? void 0 : token.decimals) || 12).toNumber(6);
      const poolId = this.getPoolId(data.pool);
      return `Claim ${amount} ${token === null || token === void 0 ? void 0 : token.display} from ${poolId || ''} earn pool`;
    } else if (type === 'payoutRewards') {
      const poolId = this.getPoolId(data.pool);
      const amount = _sdkCore.FixedPointNumber.fromInner(data.actualPayout || '0', (token === null || token === void 0 ? void 0 : token.decimals) || 12).toNumber(6);
      return `Claim ${amount} ${token === null || token === void 0 ? void 0 : token.display} from ${poolId || ''} earn pool`;
    } else if (type === 'depositDexShares') {
      const amount = _sdkCore.FixedPointNumber.fromInner(data.amount || '0', (token === null || token === void 0 ? void 0 : token.decimals) || 12).toNumber(6);
      return `Add ${amount} shares to ${token === null || token === void 0 ? void 0 : token.display} earn pool`;
    } else if (type === 'withdrawDexShares') {
      const amount = _sdkCore.FixedPointNumber.fromInner(data.amount || '0', (token === null || token === void 0 ? void 0 : token.decimals) || 12).toNumber(6);
      return `Remove ${amount} shares from ${token === null || token === void 0 ? void 0 : token.display} earn pool`;
    } else {
      return 'parse history data failed';
    }
  }
}
exports.Earns = Earns;